import { GroupMembers, MemberStatus } from 'types/member';

const memberRoles = ['collaborator', 'editor', 'viewer'];

export const getRoles = (groupMembers: GroupMembers) => {
  return memberRoles
    .map((role: string) => {
      const count = groupMembers[role as keyof GroupMembers] ?? 0;
      const isPlural = count > 1;
      const suffix = isPlural ? 's' : '';

      return `${count} ${role}${suffix}`;
    })
    .join(', ');
};

export const getStatus = (status: MemberStatus) => {
  if (status === 0) return 'Inactive'; // 비정상
  if (status === 1) return 'Active'; // 정상
  if (status === -1) return 'Deleted'; // 삭제
  if (status === -2) return 'UnVerified'; // 미인증
  if (status === -9) return 'Unknown'; // ???
  if (status === -99) return 'Withdrawn'; // 탈퇴
};

export const getIntegratedAt = (integratedAt: string) => {
  return new Date(integratedAt).toLocaleDateString('ko-KR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
};
